import { render, staticRenderFns } from "./Gen3Country.vue?vue&type=template&id=084e8d34&"
import script from "./Gen3Country.vue?vue&type=script&lang=js&"
export * from "./Gen3Country.vue?vue&type=script&lang=js&"
import style0 from "./Gen3Country.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports